import React from 'react';
import { Checkbox, FormControlLabel, Grid, MenuItem, TextField } from '@material-ui/core';
import { useFormContext } from '../FormContext';
import FormConfigTitleDescription from './FormConfigTitleDescription';
import FormConfigRequired from './FormConfigRequired';
export const FormConfigFile = () => {
    var _a;
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', label: 'File Type', value: ((_a = element.config) === null || _a === void 0 ? void 0 : _a.inputType) || '*', onChange: event => {
                    element.config.inputType = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } },
                React.createElement(MenuItem, { value: '*' }, "All file types"),
                React.createElement(MenuItem, { value: '.jpg, .jpeg, .png, .gif' }, "Image files (JPEG, PNG, GIF)"),
                React.createElement(MenuItem, { value: '.mp4, .m4v, .mov' }, "Video files (MP4, M4V, MOV)"),
                React.createElement(MenuItem, { value: '.pdf' }, "PDF only"),
                React.createElement(MenuItem, { value: '.doc, docx' }, "MS Word only"),
                React.createElement(MenuItem, { value: '.pdf, .ppt, pptx' }, "Powerpoint, Word, or PDF"))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControlLabel, { label: 'Multiple Files', control: React.createElement(Checkbox, { color: 'primary', checked: typeof element.config.multiple === 'boolean'
                        ? element.config.multiple
                        : false, onChange: () => {
                        element.config.multiple = !element.config.multiple;
                        setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                        notifyFormEdit();
                    } }) }))));
};
export default FormConfigFile;
//# sourceMappingURL=FormConfigFile.js.map